// <s-announcements>: rotates announcement messages, gliding each one up into view every 4 seconds.
// Pauses while hovered or focused, and stays on the first message when the shopper prefers reduced motion.
const TRANSITION = 'transform .7s cubic-bezier(0.32, 0.72, 0, 1), opacity .7s ease';

class SAnnouncements extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-announcement]'));
    if (this.items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.index = 0;
    this.paused = false;
    ['mouseenter', 'focusin'].forEach((e) => this.addEventListener(e, () => (this.paused = true)));
    ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => (this.paused = false)));
    this.timer = setInterval(() => {
      if (!this.paused && !document.hidden) this.next();
    }, 4000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  next() {
    const current = this.items[this.index];
    this.index = (this.index + 1) % this.items.length;
    const incoming = this.items[this.index];

    // Park the incoming message just below, without animating, then glide both.
    incoming.style.transition = 'none';
    incoming.style.transform = 'translateY(100%)';
    incoming.style.opacity = '0';
    void incoming.offsetHeight;
    incoming.style.transition = TRANSITION;
    requestAnimationFrame(() => {
      current.style.transform = 'translateY(-100%)';
      current.style.opacity = '0';
      current.setAttribute('aria-hidden', 'true');
      incoming.style.transform = 'translateY(0)';
      incoming.style.opacity = '1';
      incoming.removeAttribute('aria-hidden');
    });
  }
}
if (!customElements.get('s-announcements')) customElements.define('s-announcements', SAnnouncements);
